import { render } from "./RevenueChart.vue?vue&type=template&id=07dd2d4f&scoped=true"
import script from "./RevenueChart.vue?vue&type=script&lang=js"
export * from "./RevenueChart.vue?vue&type=script&lang=js"

import "./RevenueChart.vue?vue&type=style&index=0&id=07dd2d4f&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dd2d4f"]])

export default __exports__